import { get, post, } from '.';

export function GetSurveyAnswers(surveyId) {
	return get<any>("/app/api/surveys/" + surveyId + "/survey_answers");
}

export function CreateOrUpdateSurveyAnswers(id, options = {}) {
	return post<any>("/app/api/surveys/" + (id || 0).toString() + "/survey_answers", options);
}
